'use client';

import Link from '@eliadmin/core/src/components/link';
import { trackUserActions } from './analytics-helper';
import type { ReactNode } from 'react';

type TrackedContactLinkProps = {
  type: 'phone' | 'email';
  value?: string | null;
  className?: string;
  children?: ReactNode;
  target?: string;
  prefetch?: boolean;
};

export function TrackedContactLink({
  type,
  value,
  className,
  children,
  target,
  prefetch = false,
}: TrackedContactLinkProps) {
  const normalized = (value ?? '').trim();
  const href = type === 'phone' ? `tel:${normalized.replace(/\s/g, '')}` : `mailto:${normalized}`;

  const handleClick = () => {
    if (!normalized) return;
    if (type === 'phone') {
      trackUserActions.clickPhone(normalized, { link_url: href });
    } else {
      trackUserActions.clickEmail(normalized, { link_url: href });
    }
  };

  return normalized ? (
    <Link
      prefetch={prefetch}
      target={target}
      href={href}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Link>
  ) : (
    <span className={className}>{children}</span>
  );
}
